export function detectApplicationName(doc = typeof document !== 'undefined' ? document : undefined) {
  if (!doc) return undefined;

  return doc.getElementById('application-name')?.value || undefined;
}
